const breadCrumb = "Lançamento de Notas - Lançar Justificativas";

const routes = [
  {
    path: "/permitir-lancar-justificativa-de-faltas-por-aluno",
    name: "permitir-lancar-justificativa-de-faltas-por-aluno",
    meta: {
      allowedPermissions: [
        "faltas_justificadas_list",
        "faltas_justificadas_consultar",
        "faltas_justificadas_tempos_aulas_list",
      ],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/PermitirLancarJustificativaDeFaltasPorAluno/PermitirLancarJustificativaDeFaltasPorAlunoHome.vue"
      ),
  },
  {
    path: "/permitir-lancar-justificativa-de-faltas-por-aluno/:alunoId/:matriculaId/:escolaId/:anoMatricula/lancar",
    name: "permitir-lancar-justificativa-de-faltas-por-aluno-lancar",
    meta: {
      allowedPermissions: [
        "faltas_justificadas_list",
        "faltas_justificadas_consultar",
        "faltas_justificadas_tempos_aulas_list",
        "faltas_justificadas_create",
        "faltas_justificadas_insert",
      ],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/PermitirLancarJustificativaDeFaltasPorAluno/PermitirLancarJustificativaDeFaltasPorAlunoLancar.vue"
      ),
  },
  {
    path: "/permitir-lancar-justificativa-de-faltas-por-aluno/:alunoId/:matriculaId/:escolaId/:anoMatricula/lancar/:justificativaId/editar",
    name: "permitir-lancar-justificativa-de-faltas-por-aluno-lancar-editar",
    meta: {
      allowedPermissions: [
        "faltas_justificadas_list",
        "faltas_justificadas_consultar",
        "faltas_justificadas_tempos_aulas_list",
        "faltas_justificadas_create",
        "faltas_justificadas_insert",
      ],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/PermitirLancarJustificativaDeFaltasPorAluno/PermitirLancarJustificativaDeFaltasPorAlunoLancarEditar.vue"
      ),
  },
  {
    path: "/permitir-lancar-justificativa-de-faltas-por-aluno/:alunoId/:matriculaId/lancar/:justificativaId/consultar",
    name: "permitir-lancar-justificativa-de-faltas-por-aluno-lancar-consultar",
    meta: {
      allowedPermissions: [
        "faltas_justificadas_list",
        "faltas_justificadas_consultar",
        "faltas_justificadas_tempos_aulas_list",
      ],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/PermitirLancarJustificativaDeFaltasPorAluno/PermitirLancarJustificativaDeFaltasPorAlunoLancarConsultar.vue"
      ),
  },
];

export default routes;
